import { BrandfolderHexColors, ButtonLink, ButtonLooks, FontIconColors, FontIcons } from '@brandfolder/react';
import { Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const BackButtonLink = styled(ButtonLink)`
  color: ${BrandfolderHexColors.PurplePopsicle};
  min-height: unset;
  padding: 0;

  span {
    font-weight: 500;
  }

  &:hover {
    background-color: transparent;
    color: #314CA9;
  }
`;

interface BackButtonProps {
  handleNavigateBack?: () => void;
}

export const BackButton: FunctionComponent<BackButtonProps> = ({ handleNavigateBack }) => {
  const navigate = useNavigate();
  const goBack = (): void => navigate(-1);

  return (
    <BackButtonLink
      className="back-button"
      look={ButtonLooks.Default}
      onClick={(): void => {
        if (handleNavigateBack) {
          handleNavigateBack();
        } else goBack();
      }}
      startIcon={FontIcons.ArrowLeft}
      startIconProps={{ iconSize: 12, color: FontIconColors.Primary }}
    >
      <Trans>Back</Trans>
    </BackButtonLink>
  );
};
